"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../data/constants");
var DirectEntry = /** @class */ (function () {
    function DirectEntry() {
        DirectEntry.signets = document.querySelectorAll("[".concat(constants_1.DATA_DIRECT_ENTRY_SIGNET, "]"));
        if (DirectEntry.signets && !(DirectEntry.signets.length > 0))
            return;
        this.initEventListeners();
    }
    DirectEntry.prototype.initEventListeners = function () {
        document.addEventListener('scroll', this.onScroll);
    };
    DirectEntry.prototype.onScroll = function () {
        DirectEntry.signets.forEach(function (signet) {
            signet.style.transform = "rotate(".concat(window.scrollY / 2, "deg)");
        });
    };
    return DirectEntry;
}());
exports.default = DirectEntry;
